module.exports = __webpack_public_path__ + "img/logo-orcamento.577f6d92.png";